import { NgModule } from '@angular/core';

import { DynamicSvgComponent } from './dynamic-svg.component';

@NgModule({
  declarations: [DynamicSvgComponent],
  exports: [DynamicSvgComponent],
})
export class SvgModule {}
